import React, { useEffect, useState } from "react";
import "./styles.sass";

export const ImageZoomModal = ({ image, onClose }) => {
  const [scale, setScale] = useState(1.5);

  useEffect(() => {
    if (!image) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [image, onClose]);

  if (!image) return null;

  return (
    <div
      className="qb_image_zoom_overlay"
      onClick={onClose}
    >
      <div
        className="qb_image_zoom_modal"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="zoom_modal_header">
          <div
            className="zoom_modal_title"
            style={{ display: "flex", alignItems: "center", gap: "8px" }}
          >
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#4318D1"
              strokeWidth="2.5"
            >
              <circle cx="11" cy="11" r="8"></circle>
              <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
              <line x1="11" y1="8" x2="11" y2="14"></line>
              <line x1="8" y1="11" x2="14" y2="11"></line>
            </svg>
            <span>{image.title || "Image Preview & Zoom"}</span>
          </div>
          <div className="zoom_controls_group">
            <button
              type="button"
              className="zoom_ctrl_btn"
              title="Zoom Out"
              onClick={() => setScale((prev) => Math.max(0.5, prev - 0.25))}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                <line x1="8" y1="11" x2="14" y2="11"></line>
              </svg>
            </button>
            <span className="zoom_scale_indicator">
              {Math.round(scale * 100)}%
            </span>
            <button
              type="button"
              className="zoom_ctrl_btn"
              title="Zoom In"
              onClick={() => setScale((prev) => Math.min(3.5, prev + 0.25))}
            >
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                <line x1="11" y1="8" x2="11" y2="14"></line>
                <line x1="8" y1="11" x2="14" y2="11"></line>
              </svg>
            </button>
            <button
              type="button"
              className="zoom_ctrl_btn reset_btn"
              title="Reset Zoom"
              onClick={() => setScale(1.5)}
            >
              Reset
            </button>
            <button
              type="button"
              className="zoom_close_btn"
              title="Close (Esc)"
              onClick={onClose}
            >
              ×
            </button>
          </div>
        </div>
        <div className="zoom_modal_body">
          <div className="zoom_img_scroll_container">
            <img
              src={image.src}
              alt={image.title || "Zoomed diagram"}
              className="zoom_preview_img"
              style={{ transform: `scale(${scale})` }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export const QuizImagePreview = ({
  src,
  alt = "Diagram",
  title = "Diagram",
  className = "ws_q_diagram_img",
  containerClassName = "",
  isOption = false,
  onZoom,
}) => {
  if (!src) return null;

  const handleZoomClick = (e) => {
    if (e) {
      if (typeof e.preventDefault === "function") e.preventDefault();
      if (typeof e.stopPropagation === "function") e.stopPropagation();
    }
    if (onZoom) {
      onZoom({ src, title });
    }
  };

  return (
    <div className={`img_preview_box ${isOption ? "opt_box" : ""} ${containerClassName}`}>
      <img
        src={src}
        alt={alt}
        className={className}
        loading="lazy"
        onClick={handleZoomClick}
      />
      <div
        role="button"
        tabIndex={0}
        className={`img_zoom_action_btn ${isOption ? "opt_zoom_btn" : ""}`}
        title="Click to Zoom In"
        onClick={handleZoomClick}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            handleZoomClick(e);
          }
        }}
      >
        <svg
          width={isOption ? "11" : "12"}
          height={isOption ? "11" : "12"}
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.5"
        >
          <circle cx="11" cy="11" r="8"></circle>
          <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
          <line x1="11" y1="8" x2="11" y2="14"></line>
          <line x1="8" y1="11" x2="14" y2="11"></line>
        </svg>
        <span>Zoom In</span>
      </div>
    </div>
  );
};

export default ImageZoomModal;
